import { PermissionsType } from '@/common/permissionsConst';

export const qingflowWorkDetailPath = `${window.SELECTSTAFFORIGIN}/ql/platform/${PermissionsType.P_QL_WORK_ALARM}`;
